import { DownloadWindowController } from '../controller/DownloadWindowController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class DownloadWindowWebComponent extends BaseWebComponentElement {
  private _maxFilesSize: number = 0;

  controller: DownloadWindowController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: DownloadWindowController,
    });
  }

  get streamId(): string {
    return this.getAttribute('data-stream-id') ?? '';
  }

  set streamId(value: string | null) {
    this.setAttribute('data-stream-id', value || '');
  }

  get path(): string {
    return this.getAttribute('data-path') ?? '';
  }

  set path(value: string) {
    this.setAttribute('data-path', value);
  }

  get password(): string {
    return this.getAttribute('data-password') ?? '';
  }

  set password(value: string) {
    this.setAttribute('data-password', value);
  }

  get repeatPassword(): string {
    return this.getAttribute('data-repeat-password') ?? '';
  }

  set repeatPassword(value: string) {
    this.setAttribute('data-repeat-password', value);
  }


  set maxFilesSize(value: number) {
    this._maxFilesSize = value
  }

  get maxFilesSize(): number {
    return this._maxFilesSize;
  }

  isPasswordProtected(): boolean {
    return this.controller.view.dom.$passwordProtectToggle.getFormValue();
  }

  isValid() {
    const passwordProtect = this.controller.view.dom.$passwordProtectToggle.getFormValue();
    if (passwordProtect) {
      return (
        this.controller.view.dom.$downloadPathField.valid &&
        this.controller.view.dom.$archivePasswordFormField.valid &&
        this.controller.view.dom.$repeatPasswordFormField.valid
      );
    }

    return this.controller.view.dom.$downloadPathField.valid;
  }

  async validate() {
    await this.controller.validateDownloadPath();
  }
}
